export enum Page {
  homepage = '/',
  goto = '/gt',
}
